export const initializeFosse = async () => {
  const [React, ReactDOM, { Fosse }] = await Promise.all([
    import('react'),
    import('react-dom'),
    import('../lib'),
  ])

  const fosse = new Fosse()

  const [
    { BabyGrowl, CliffTakeover, Reset },
    { Egyptienne, LibreFranklin, MillerText },
  ] = await Promise.all([
    import('@nymag/paywall-reader-interface/components/index.js'),
    import('@nymag/paywall-reader-interface/assets/fonts/index.js'),
  ])

  const ToutTree = ({ toutData, toutType }) => {
    const onSignIn = React.useCallback(
      () =>
        fosse.sendMessage('tout:sign-in', {
          toutType,
        }),
      [toutType],
    )

    const onDismiss = React.useCallback(
      () =>
        fosse.sendMessage('tout:dismiss', {
          toutType,
        }),
      [toutType],
    )

    const onSubscribe = React.useCallback(
      () =>
        fosse.sendMessage('tout:subscribe', {
          toutType,
        }),
      [toutType],
    )

    return (
      <>
        <Reset />
        <Egyptienne />
        <LibreFranklin />
        <MillerText />
        { toutType === 'baby-growl' && (
          <BabyGrowl
            { ...toutData }
            visible={ toutType && toutType === 'baby-growl' }
            onDismiss={ onDismiss }
            onSubscribe={ onSubscribe } />
        ) }

        { (toutType === 'cliff-takeover' || toutType === 'warning-growl-2') && (
          <CliffTakeover
            { ...toutData }
            dismissible={ toutType === 'warning-growl-2' }
            visible={
              toutType &&
              (toutType === 'cliff-takeover' || toutType === 'warning-growl-2')
            }
            onDismiss={ onDismiss }
            onSignIn={ onSignIn }
            onSubscribe={ onSubscribe } />
        ) }
      </>
    )
  }

  const main = document.querySelector('main')

  const renderPaywall = ({ toutData, toutType } = {}) => {
    ReactDOM.render(<ToutTree toutData={ toutData } toutType={ toutType } />, main)

    requestAnimationFrame(
      () => toutType && fosse.sendMessage('tout:visible', { toutType }),
    )
  }

  document.addEventListener('load', () => {
    renderPaywall()
  })

  // FIXME: This nested object stuff is a mess.
  fosse.on('tout:show', ({ payload: { toutData, toutType } = {} } = {}) => {
    renderPaywall({ toutData, toutType })
  })

  fosse.on('tout:hide', () => {
    renderPaywall()
  })

  // Event to get the iframe content's height
  fosse.on('frame:height', () => {
    const currentHeight = document.querySelector('.tout').offsetHeight

    fosse.sendMessage('frame:height', { currentHeight })
  })
}
